import { Text, Progress, Box, Divider, Flex } from '@chakra-ui/react';

const CountLimit = ({ entitlement }) => {
  return (
    <>
      <Text textStyle="bodyFamilySemiBold" fontSize="18px">
        {entitlement.name}
      </Text>
      <Divider border="1px solid lightGrey" mt={2} />
      <Box mt={6}>
        <Flex
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text textStyle="heading3">{entitlement.currentValue}</Text>
          <Text textStyle="bodySmall" color="#979797">
            of {entitlement.limitValue}
          </Text>
        </Flex>
        <Progress
          variant="gradient"
          height="0.9rem"
          width="100%"
          borderRadius="4px"
          value={(entitlement.currentValue / entitlement.limitValue) * 100}
          alignSelf="center"
        />
      </Box>
    </>
  );
};

export default CountLimit;
